import { render, staticRenderFns } from "./footer-cmp.vue?vue&type=template&id=3eaf0d58&scoped=true"
import script from "./footer-cmp.vue?vue&type=script&lang=js"
export * from "./footer-cmp.vue?vue&type=script&lang=js"
import style0 from "./footer-cmp.vue?vue&type=style&index=0&id=3eaf0d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaf0d58",
  null
  
)

export default component.exports